import { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer sees the AI chatbot tooltip
 */
export const RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN =
  'RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN' as IUserMilestone.RetailerMilestone;
